module.exports = __webpack_public_path__ + "static/scale-model-of-visitor-center-at-steelstacks-in-allentown-pennsylvania-0198d6e12755d5ecf5c5f1f1c163beb8.png";